import React from 'react';
import { Route } from 'react-router-dom';
import Result from './Result';
import ResultDetail from './ResultDetail';
import Search from './Search';
import Wait from './Wait';

const routers = [
  <Route key="/result" path="*/result" exact component={Result} />, // 搜索结果首页
  <Route key="/result/detail" path="*/result/detail" exact component={ResultDetail} />, // 搜索结果详情页
  <Route key="/search" path="*/search" component={Search} />, // 搜索
  <Route key="/wait" path="*/wait" component={Wait} />, // 等待
];

export default routers;
